/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Recap
 * OpenAPI spec version: 1
 */
import * as zod from 'zod';

import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import { useApiFetch } from '../client.ts';
import type { ErrorType } from '../client.ts';
import { useMutationBehavior } from '../mutations.ts';
import { useQueryBehavior } from '../queries.ts';
import {
    BoardList,
    Calendar,
    Connection,
    ConnectionCreated,
    ConnectionToken,
    ExternalCompany,
    ExternalContact,
    Feed,
    FeedRoute,
    HubSpotLifecycleStage,
    JiraProject,
    MailFolder,
    OAuthStartResult,
    OdooFolder,
    OdooProject,
    OdooTag,
    PagedExternalCompany,
    PickItem,
    PickPlace,
    PickerConfig,
    Provider,
    Repository,
    RoutePreview,
    TodoList,
} from './schemas.ts';
import type {
    ConnectionInput,
    ConnectionTest,
    ConnectionUpdate,
    EmailAddressUpdate,
    ErrorResponse,
    ExternalCompanyUpdate,
    FeedInput,
    FeedRouteInput,
    FeedRouteUpdate,
    FeedUpdate,
    ListBoardListsParams,
    ListExternalCompaniesParams,
    ListPickItemsParams,
    OAuthStart,
    RoutePreviewInput,
} from './schemas.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getListProvidersUrl = () => {
    return `/workspace/integrations/providers`;
};

/**
 * @summary List Providers
 */
export const useListProvidersHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Provider[]>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListProvidersUrl(), {
            ...options,
            method: 'GET',

            schema: zod.array(Provider),
        });
    };
};

export const getListProvidersQueryKey = () => {
    return ['workspace', 'integrations', 'providers'] as const;
};

export const useListProvidersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListProvidersQueryKey();

    const listProviders = useListProvidersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>> = ({ signal }) =>
        listProviders({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        { url: `/workspace/integrations/providers`, operationId: 'list_providers', operationName: 'listProviders' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListProvidersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>>;
export type ListProvidersQueryError = ErrorType<ErrorResponse>;

export function useListProviders<
    TData = Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListProviders<
    TData = Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListProviders<
    TData = Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Providers
 */

export function useListProviders<
    TData = Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListProvidersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListProvidersQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListConnectionsUrl = () => {
    return `/workspace/connections`;
};

/**
 * @summary List Connections
 */
export const useListConnectionsHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Connection[]>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListConnectionsUrl(), {
            ...options,
            method: 'GET',

            schema: zod.array(Connection),
        });
    };
};

export const getListConnectionsQueryKey = () => {
    return ['workspace', 'connections'] as const;
};

export const useListConnectionsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListConnectionsQueryKey();

    const listConnections = useListConnectionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>> = ({ signal }) =>
        listConnections({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        { url: `/workspace/connections`, operationId: 'list_connections', operationName: 'listConnections' }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConnectionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>>;
export type ListConnectionsQueryError = ErrorType<ErrorResponse>;

export function useListConnections<
    TData = Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListConnections<
    TData = Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListConnections<
    TData = Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Connections
 */

export function useListConnections<
    TData = Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListConnectionsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListConnectionsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateConnectionUrl = () => {
    return `/workspace/connections`;
};

/**
 * @summary Create Connection
 */
export const useCreateConnectionHook = (): ((
    connectionInput: ConnectionInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<ConnectionCreated>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (connectionInput: ConnectionInput, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getCreateConnectionUrl(), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(connectionInput),
            schema: ConnectionCreated,
        });
    };
};

export const getCreateConnectionMutationKey = () => ['createConnection'] as const;

export const useCreateConnectionMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateConnectionHook>>>,
        TError,
        CreateConnectionMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateConnectionHook>>>,
    TError,
    CreateConnectionMutationVariables,
    TContext
> => {
    const mutationKey = getCreateConnectionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const createConnection = useCreateConnectionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateConnectionHook>>>,
        CreateConnectionMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return createConnection(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/connections` },
        { operationId: 'create_connection', operationName: 'createConnection' }
    );

    return customOptions;
};

export type CreateConnectionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateConnectionHook>>>
>;
export type CreateConnectionMutationBody = ConnectionInput;
export type CreateConnectionMutationError = ErrorType<ErrorResponse>;
export type CreateConnectionMutationVariables = { data: ConnectionInput };

/**
 * @summary Create Connection
 */
export const useCreateConnection = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateConnectionHook>>>,
            TError,
            CreateConnectionMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateConnectionHook>>>,
    TError,
    CreateConnectionMutationVariables,
    TContext
> => {
    return useMutation(useCreateConnectionMutationOptions(options), queryClient);
};
export const getCheckConnectionUrl = () => {
    return `/workspace/connections/test-connection`;
};

/**
 * @summary Check Connection
 */
export const useCheckConnectionHook = (): ((
    connectionTest: ConnectionTest,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (connectionTest: ConnectionTest, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getCheckConnectionUrl(), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(connectionTest),
        });
    };
};

export const getCheckConnectionMutationKey = () => ['checkConnection'] as const;

export const useCheckConnectionMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCheckConnectionHook>>>,
        TError,
        CheckConnectionMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCheckConnectionHook>>>,
    TError,
    CheckConnectionMutationVariables,
    TContext
> => {
    const mutationKey = getCheckConnectionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const checkConnection = useCheckConnectionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCheckConnectionHook>>>,
        CheckConnectionMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return checkConnection(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/connections/test-connection` },
        { operationId: 'check_connection', operationName: 'checkConnection' }
    );

    return customOptions;
};

export type CheckConnectionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCheckConnectionHook>>>>;
export type CheckConnectionMutationBody = ConnectionTest;
export type CheckConnectionMutationError = ErrorType<ErrorResponse>;
export type CheckConnectionMutationVariables = { data: ConnectionTest };

/**
 * @summary Check Connection
 */
export const useCheckConnection = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCheckConnectionHook>>>,
            TError,
            CheckConnectionMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCheckConnectionHook>>>,
    TError,
    CheckConnectionMutationVariables,
    TContext
> => {
    return useMutation(useCheckConnectionMutationOptions(options), queryClient);
};
export const getStartOauthUrl = () => {
    return `/workspace/connections/oauth`;
};

/**
 * @summary Start Oauth
 */
export const useStartOauthHook = (): ((
    oAuthStart: OAuthStart,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<OAuthStartResult>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (oAuthStart: OAuthStart, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getStartOauthUrl(), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(oAuthStart),
            schema: OAuthStartResult,
        });
    };
};

export const getStartOauthMutationKey = () => ['startOauth'] as const;

export const useStartOauthMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useStartOauthHook>>>,
        TError,
        StartOauthMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useStartOauthHook>>>,
    TError,
    StartOauthMutationVariables,
    TContext
> => {
    const mutationKey = getStartOauthMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const startOauth = useStartOauthHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useStartOauthHook>>>,
        StartOauthMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return startOauth(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/connections/oauth` },
        { operationId: 'start_oauth', operationName: 'startOauth' }
    );

    return customOptions;
};

export type StartOauthMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useStartOauthHook>>>>;
export type StartOauthMutationBody = OAuthStart;
export type StartOauthMutationError = ErrorType<ErrorResponse>;
export type StartOauthMutationVariables = { data: OAuthStart };

/**
 * @summary Start Oauth
 */
export const useStartOauth = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useStartOauthHook>>>,
            TError,
            StartOauthMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useStartOauthHook>>>,
    TError,
    StartOauthMutationVariables,
    TContext
> => {
    return useMutation(useStartOauthMutationOptions(options), queryClient);
};
export const getListPickPlacesUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/places`;
};

/**
 * @summary List Pick Places
 */
export const useListPickPlacesHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<PickPlace[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListPickPlacesUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(PickPlace),
        });
    };
};

export const getListPickPlacesQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'places'] as const;
};

export const useListPickPlacesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListPickPlacesQueryKey(connectionId);

    const listPickPlaces = useListPickPlacesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>> = ({ signal }) =>
        listPickPlaces(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/places`,
            operationId: 'list_pick_places',
            operationName: 'listPickPlaces',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPickPlacesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>>;
export type ListPickPlacesQueryError = ErrorType<ErrorResponse>;

export function useListPickPlaces<
    TData = Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPickPlaces<
    TData = Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPickPlaces<
    TData = Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Pick Places
 */

export function useListPickPlaces<
    TData = Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickPlacesHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListPickPlacesQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListPickItemsUrl = (connectionId: string | null, params?: ListPickItemsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/workspace/connections/${connectionId}/items?${stringifiedParams}`
        : `/workspace/connections/${connectionId}/items`;
};

/**
 * @summary List Pick Items
 */
export const useListPickItemsHook = (): ((
    connectionId: string | null,
    params?: ListPickItemsParams,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<PickItem[]>) => {
    const customFetcher = useApiFetch();
    return (
        connectionId: string | null,
        params?: ListPickItemsParams,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getListPickItemsUrl(connectionId, params), {
            ...options,
            method: 'GET',

            schema: zod.array(PickItem),
        });
    };
};

export const getListPickItemsQueryKey = (connectionId: string | null, params?: ListPickItemsParams) => {
    return ['workspace', 'connections', connectionId, 'items', ...(params ? [params] : [])] as const;
};

export const useListPickItemsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params?: ListPickItemsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListPickItemsQueryKey(connectionId, params);

    const listPickItems = useListPickItemsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>> = ({ signal }) =>
        listPickItems(connectionId, params, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId, params },
        {
            url: `/workspace/connections/${connectionId}/items`,
            operationId: 'list_pick_items',
            operationName: 'listPickItems',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPickItemsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>>;
export type ListPickItemsQueryError = ErrorType<ErrorResponse>;

export function useListPickItems<
    TData = Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params: undefined | ListPickItemsParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPickItems<
    TData = Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params?: ListPickItemsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPickItems<
    TData = Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params?: ListPickItemsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Pick Items
 */

export function useListPickItems<
    TData = Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params?: ListPickItemsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListPickItemsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListPickItemsQueryOptions(connectionId, params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPickerConfigUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/picker`;
};

/**
 * @summary Get Picker Config
 */
export const useGetPickerConfigHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<PickerConfig>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getGetPickerConfigUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: PickerConfig,
        });
    };
};

export const getGetPickerConfigQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'picker'] as const;
};

export const useGetPickerConfigQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPickerConfigQueryKey(connectionId);

    const getPickerConfig = useGetPickerConfigHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>> = ({ signal }) =>
        getPickerConfig(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/picker`,
            operationId: 'get_picker_config',
            operationName: 'getPickerConfig',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPickerConfigQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>>;
export type GetPickerConfigQueryError = ErrorType<ErrorResponse>;

export function useGetPickerConfig<
    TData = Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPickerConfig<
    TData = Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPickerConfig<
    TData = Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Picker Config
 */

export function useGetPickerConfig<
    TData = Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPickerConfigHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useGetPickerConfigQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateConnectionUrl = (connectionId: string) => {
    return `/workspace/connections/${connectionId}`;
};

/**
 * @summary Update Connection
 */
export const useUpdateConnectionHook = (): ((
    connectionId: string,
    connectionUpdate: ConnectionUpdate,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Connection>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (
        connectionId: string,
        connectionUpdate: ConnectionUpdate,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getUpdateConnectionUrl(connectionId), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(connectionUpdate),
            schema: Connection,
        });
    };
};

export const getUpdateConnectionMutationKey = () => ['updateConnection'] as const;

export const useUpdateConnectionMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateConnectionHook>>>,
        TError,
        UpdateConnectionMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateConnectionHook>>>,
    TError,
    UpdateConnectionMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateConnectionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateConnection = useUpdateConnectionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateConnectionHook>>>,
        UpdateConnectionMutationVariables
    > = (props) => {
        const { connectionId, data } = props ?? {};

        return updateConnection(connectionId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/connections/{connectionId}` },
        { operationId: 'update_connection', operationName: 'updateConnection' }
    );

    return customOptions;
};

export type UpdateConnectionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateConnectionHook>>>
>;
export type UpdateConnectionMutationBody = ConnectionUpdate;
export type UpdateConnectionMutationError = ErrorType<ErrorResponse>;
export type UpdateConnectionMutationVariables = { connectionId: string; data: ConnectionUpdate };

/**
 * @summary Update Connection
 */
export const useUpdateConnection = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateConnectionHook>>>,
            TError,
            UpdateConnectionMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateConnectionHook>>>,
    TError,
    UpdateConnectionMutationVariables,
    TContext
> => {
    return useMutation(useUpdateConnectionMutationOptions(options), queryClient);
};
export const getDeleteConnectionUrl = (connectionId: string) => {
    return `/workspace/connections/${connectionId}`;
};

/**
 * @summary Delete Connection
 */
export const useDeleteConnectionHook = (): ((
    connectionId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getDeleteConnectionUrl(connectionId), {
            ...options,
            method: 'DELETE',
        });
    };
};

export const getDeleteConnectionMutationKey = () => ['deleteConnection'] as const;

export const useDeleteConnectionMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteConnectionHook>>>,
        TError,
        DeleteConnectionMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteConnectionHook>>>,
    TError,
    DeleteConnectionMutationVariables,
    TContext
> => {
    const mutationKey = getDeleteConnectionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const deleteConnection = useDeleteConnectionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteConnectionHook>>>,
        DeleteConnectionMutationVariables
    > = (props) => {
        const { connectionId } = props ?? {};

        return deleteConnection(connectionId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/connections/{connectionId}` },
        { operationId: 'delete_connection', operationName: 'deleteConnection' }
    );

    return customOptions;
};

export type DeleteConnectionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteConnectionHook>>>
>;

export type DeleteConnectionMutationError = ErrorType<ErrorResponse>;
export type DeleteConnectionMutationVariables = { connectionId: string };

/**
 * @summary Delete Connection
 */
export const useDeleteConnection = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeleteConnectionHook>>>,
            TError,
            DeleteConnectionMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteConnectionHook>>>,
    TError,
    DeleteConnectionMutationVariables,
    TContext
> => {
    return useMutation(useDeleteConnectionMutationOptions(options), queryClient);
};
export const getRenewConnectionTokenUrl = (connectionId: string) => {
    return `/workspace/connections/${connectionId}/token`;
};

/**
 * @summary Renew Connection Token
 */
export const useRenewConnectionTokenHook = (): ((
    connectionId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<ConnectionToken>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getRenewConnectionTokenUrl(connectionId), {
            ...options,
            method: 'POST',

            schema: ConnectionToken,
        });
    };
};

export const getRenewConnectionTokenMutationKey = () => ['renewConnectionToken'] as const;

export const useRenewConnectionTokenMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRenewConnectionTokenHook>>>,
        TError,
        RenewConnectionTokenMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRenewConnectionTokenHook>>>,
    TError,
    RenewConnectionTokenMutationVariables,
    TContext
> => {
    const mutationKey = getRenewConnectionTokenMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const renewConnectionToken = useRenewConnectionTokenHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useRenewConnectionTokenHook>>>,
        RenewConnectionTokenMutationVariables
    > = (props) => {
        const { connectionId } = props ?? {};

        return renewConnectionToken(connectionId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/connections/{connectionId}/token` },
        { operationId: 'renew_connection_token', operationName: 'renewConnectionToken' }
    );

    return customOptions;
};

export type RenewConnectionTokenMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useRenewConnectionTokenHook>>>
>;

export type RenewConnectionTokenMutationError = ErrorType<ErrorResponse>;
export type RenewConnectionTokenMutationVariables = { connectionId: string };

/**
 * @summary Renew Connection Token
 */
export const useRenewConnectionToken = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useRenewConnectionTokenHook>>>,
            TError,
            RenewConnectionTokenMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useRenewConnectionTokenHook>>>,
    TError,
    RenewConnectionTokenMutationVariables,
    TContext
> => {
    return useMutation(useRenewConnectionTokenMutationOptions(options), queryClient);
};
export const getListBoardListsUrl = (connectionId: string | null, params: ListBoardListsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/workspace/connections/${connectionId}/board-lists?${stringifiedParams}`
        : `/workspace/connections/${connectionId}/board-lists`;
};

/**
 * @summary List Board Lists
 */
export const useListBoardListsHook = (): ((
    connectionId: string | null,
    params: ListBoardListsParams,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<BoardList[]>) => {
    const customFetcher = useApiFetch();
    return (
        connectionId: string | null,
        params: ListBoardListsParams,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getListBoardListsUrl(connectionId, params), {
            ...options,
            method: 'GET',

            schema: zod.array(BoardList),
        });
    };
};

export const getListBoardListsQueryKey = (connectionId: string | null, params?: ListBoardListsParams) => {
    return ['workspace', 'connections', connectionId, 'board-lists', ...(params ? [params] : [])] as const;
};

export const useListBoardListsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params: ListBoardListsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListBoardListsQueryKey(connectionId, params);

    const listBoardLists = useListBoardListsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>> = ({ signal }) =>
        listBoardLists(connectionId, params, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId, params },
        {
            url: `/workspace/connections/${connectionId}/board-lists`,
            operationId: 'list_board_lists',
            operationName: 'listBoardLists',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBoardListsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>>;
export type ListBoardListsQueryError = ErrorType<ErrorResponse>;

export function useListBoardLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params: ListBoardListsParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBoardLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params: ListBoardListsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListBoardLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params: ListBoardListsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Board Lists
 */

export function useListBoardLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    params: ListBoardListsParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListBoardListsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListBoardListsQueryOptions(connectionId, params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListMailFoldersUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/mail-folders`;
};

/**
 * @summary List Mail Folders
 */
export const useListMailFoldersHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<MailFolder[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListMailFoldersUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(MailFolder),
        });
    };
};

export const getListMailFoldersQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'mail-folders'] as const;
};

export const useListMailFoldersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListMailFoldersQueryKey(connectionId);

    const listMailFolders = useListMailFoldersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>> = ({ signal }) =>
        listMailFolders(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/mail-folders`,
            operationId: 'list_mail_folders',
            operationName: 'listMailFolders',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMailFoldersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>>;
export type ListMailFoldersQueryError = ErrorType<ErrorResponse>;

export function useListMailFolders<
    TData = Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMailFolders<
    TData = Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMailFolders<
    TData = Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Mail Folders
 */

export function useListMailFolders<
    TData = Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListMailFoldersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListMailFoldersQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListCalendarsUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/calendars`;
};

/**
 * @summary List Calendars
 */
export const useListCalendarsHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Calendar[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListCalendarsUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(Calendar),
        });
    };
};

export const getListCalendarsQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'calendars'] as const;
};

export const useListCalendarsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListCalendarsQueryKey(connectionId);

    const listCalendars = useListCalendarsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>> = ({ signal }) =>
        listCalendars(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/calendars`,
            operationId: 'list_calendars',
            operationName: 'listCalendars',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCalendarsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>>;
export type ListCalendarsQueryError = ErrorType<ErrorResponse>;

export function useListCalendars<
    TData = Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCalendars<
    TData = Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListCalendars<
    TData = Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Calendars
 */

export function useListCalendars<
    TData = Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListCalendarsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListCalendarsQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListTodoListsUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/todo-lists`;
};

/**
 * @summary List Todo Lists
 */
export const useListTodoListsHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<TodoList[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListTodoListsUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(TodoList),
        });
    };
};

export const getListTodoListsQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'todo-lists'] as const;
};

export const useListTodoListsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListTodoListsQueryKey(connectionId);

    const listTodoLists = useListTodoListsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>> = ({ signal }) =>
        listTodoLists(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/todo-lists`,
            operationId: 'list_todo_lists',
            operationName: 'listTodoLists',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTodoListsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>>;
export type ListTodoListsQueryError = ErrorType<ErrorResponse>;

export function useListTodoLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTodoLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListTodoLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Todo Lists
 */

export function useListTodoLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListTodoListsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListTodoListsQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListRepositoriesUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/repositories`;
};

/**
 * @summary List Repositories
 */
export const useListRepositoriesHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Repository[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListRepositoriesUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(Repository),
        });
    };
};

export const getListRepositoriesQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'repositories'] as const;
};

export const useListRepositoriesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListRepositoriesQueryKey(connectionId);

    const listRepositories = useListRepositoriesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>> = ({ signal }) =>
        listRepositories(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/repositories`,
            operationId: 'list_repositories',
            operationName: 'listRepositories',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListRepositoriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>>;
export type ListRepositoriesQueryError = ErrorType<ErrorResponse>;

export function useListRepositories<
    TData = Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListRepositories<
    TData = Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListRepositories<
    TData = Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Repositories
 */

export function useListRepositories<
    TData = Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListRepositoriesHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListRepositoriesQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListJiraProjectsUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/jira-projects`;
};

/**
 * @summary List Jira Projects
 */
export const useListJiraProjectsHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<JiraProject[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListJiraProjectsUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(JiraProject),
        });
    };
};

export const getListJiraProjectsQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'jira-projects'] as const;
};

export const useListJiraProjectsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListJiraProjectsQueryKey(connectionId);

    const listJiraProjects = useListJiraProjectsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>> = ({ signal }) =>
        listJiraProjects(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/jira-projects`,
            operationId: 'list_jira_projects',
            operationName: 'listJiraProjects',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListJiraProjectsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>>;
export type ListJiraProjectsQueryError = ErrorType<ErrorResponse>;

export function useListJiraProjects<
    TData = Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListJiraProjects<
    TData = Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListJiraProjects<
    TData = Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Jira Projects
 */

export function useListJiraProjects<
    TData = Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListJiraProjectsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListJiraProjectsQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListOdooTagsUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/odoo-tags`;
};

/**
 * @summary List Odoo Tags
 */
export const useListOdooTagsHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<OdooTag[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListOdooTagsUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(OdooTag),
        });
    };
};

export const getListOdooTagsQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'odoo-tags'] as const;
};

export const useListOdooTagsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListOdooTagsQueryKey(connectionId);

    const listOdooTags = useListOdooTagsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>> = ({ signal }) =>
        listOdooTags(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/odoo-tags`,
            operationId: 'list_odoo_tags',
            operationName: 'listOdooTags',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOdooTagsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>>;
export type ListOdooTagsQueryError = ErrorType<ErrorResponse>;

export function useListOdooTags<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOdooTags<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOdooTags<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Odoo Tags
 */

export function useListOdooTags<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooTagsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListOdooTagsQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListHubspotLifecycleStagesUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/hubspot-lifecycle-stages`;
};

/**
 * @summary List Hubspot Lifecycle Stages
 */
export const useListHubspotLifecycleStagesHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<HubSpotLifecycleStage[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListHubspotLifecycleStagesUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(HubSpotLifecycleStage),
        });
    };
};

export const getListHubspotLifecycleStagesQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'hubspot-lifecycle-stages'] as const;
};

export const useListHubspotLifecycleStagesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListHubspotLifecycleStagesQueryKey(connectionId);

    const listHubspotLifecycleStages = useListHubspotLifecycleStagesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>> = ({
        signal,
    }) => listHubspotLifecycleStages(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/hubspot-lifecycle-stages`,
            operationId: 'list_hubspot_lifecycle_stages',
            operationName: 'listHubspotLifecycleStages',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListHubspotLifecycleStagesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>
>;
export type ListHubspotLifecycleStagesQueryError = ErrorType<ErrorResponse>;

export function useListHubspotLifecycleStages<
    TData = Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHubspotLifecycleStages<
    TData = Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHubspotLifecycleStages<
    TData = Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Hubspot Lifecycle Stages
 */

export function useListHubspotLifecycleStages<
    TData = Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListHubspotLifecycleStagesHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListHubspotLifecycleStagesQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListOdooFoldersUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/odoo-folders`;
};

/**
 * @summary List Odoo Folders
 */
export const useListOdooFoldersHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<OdooFolder[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListOdooFoldersUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(OdooFolder),
        });
    };
};

export const getListOdooFoldersQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'odoo-folders'] as const;
};

export const useListOdooFoldersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListOdooFoldersQueryKey(connectionId);

    const listOdooFolders = useListOdooFoldersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>> = ({ signal }) =>
        listOdooFolders(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/odoo-folders`,
            operationId: 'list_odoo_folders',
            operationName: 'listOdooFolders',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOdooFoldersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>>;
export type ListOdooFoldersQueryError = ErrorType<ErrorResponse>;

export function useListOdooFolders<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOdooFolders<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOdooFolders<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Odoo Folders
 */

export function useListOdooFolders<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooFoldersHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListOdooFoldersQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListOdooProjectsUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/odoo-projects`;
};

/**
 * @summary List Odoo Projects
 */
export const useListOdooProjectsHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<OdooProject[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListOdooProjectsUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(OdooProject),
        });
    };
};

export const getListOdooProjectsQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'odoo-projects'] as const;
};

export const useListOdooProjectsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListOdooProjectsQueryKey(connectionId);

    const listOdooProjects = useListOdooProjectsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>> = ({ signal }) =>
        listOdooProjects(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/odoo-projects`,
            operationId: 'list_odoo_projects',
            operationName: 'listOdooProjects',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOdooProjectsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>>;
export type ListOdooProjectsQueryError = ErrorType<ErrorResponse>;

export function useListOdooProjects<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOdooProjects<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOdooProjects<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Odoo Projects
 */

export function useListOdooProjects<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooProjectsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListOdooProjectsQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListOdooModelsUrl = (connectionId: string | null) => {
    return `/workspace/connections/${connectionId}/odoo-models`;
};

/**
 * @summary List Odoo Models
 */
export const useListOdooModelsHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<string[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListOdooModelsUrl(connectionId), {
            ...options,
            method: 'GET',
        });
    };
};

export const getListOdooModelsQueryKey = (connectionId: string | null) => {
    return ['workspace', 'connections', connectionId, 'odoo-models'] as const;
};

export const useListOdooModelsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListOdooModelsQueryKey(connectionId);

    const listOdooModels = useListOdooModelsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>> = ({ signal }) =>
        listOdooModels(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/connections/${connectionId}/odoo-models`,
            operationId: 'list_odoo_models',
            operationName: 'listOdooModels',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOdooModelsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>>;
export type ListOdooModelsQueryError = ErrorType<ErrorResponse>;

export function useListOdooModels<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOdooModels<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListOdooModels<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Odoo Models
 */

export function useListOdooModels<
    TData = Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListOdooModelsHook>>>, TError, TData>>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListOdooModelsQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateFeedUrl = (connectionId: string) => {
    return `/workspace/connections/${connectionId}/feeds`;
};

/**
 * @summary Create Feed
 */
export const useCreateFeedHook = (): ((
    connectionId: string,
    feedInput: FeedInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (connectionId: string, feedInput: FeedInput, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getCreateFeedUrl(connectionId), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(feedInput),
            schema: Feed,
        });
    };
};

export const getCreateFeedMutationKey = () => ['createFeed'] as const;

export const useCreateFeedMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateFeedHook>>>,
        TError,
        CreateFeedMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateFeedHook>>>,
    TError,
    CreateFeedMutationVariables,
    TContext
> => {
    const mutationKey = getCreateFeedMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const createFeed = useCreateFeedHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateFeedHook>>>,
        CreateFeedMutationVariables
    > = (props) => {
        const { connectionId, data } = props ?? {};

        return createFeed(connectionId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/connections/{connectionId}/feeds` },
        { operationId: 'create_feed', operationName: 'createFeed' }
    );

    return customOptions;
};

export type CreateFeedMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateFeedHook>>>>;
export type CreateFeedMutationBody = FeedInput;
export type CreateFeedMutationError = ErrorType<ErrorResponse>;
export type CreateFeedMutationVariables = { connectionId: string; data: FeedInput };

/**
 * @summary Create Feed
 */
export const useCreateFeed = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateFeedHook>>>,
            TError,
            CreateFeedMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateFeedHook>>>,
    TError,
    CreateFeedMutationVariables,
    TContext
> => {
    return useMutation(useCreateFeedMutationOptions(options), queryClient);
};
export const getUpdateFeedUrl = (feedId: string) => {
    return `/workspace/feeds/${feedId}`;
};

/**
 * @summary Update Feed
 */
export const useUpdateFeedHook = (): ((
    feedId: string,
    feedUpdate: FeedUpdate,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (feedId: string, feedUpdate: FeedUpdate, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getUpdateFeedUrl(feedId), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(feedUpdate),
            schema: Feed,
        });
    };
};

export const getUpdateFeedMutationKey = () => ['updateFeed'] as const;

export const useUpdateFeedMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateFeedHook>>>,
        TError,
        UpdateFeedMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateFeedHook>>>,
    TError,
    UpdateFeedMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateFeedMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateFeed = useUpdateFeedHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateFeedHook>>>,
        UpdateFeedMutationVariables
    > = (props) => {
        const { feedId, data } = props ?? {};

        return updateFeed(feedId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feeds/{feedId}` },
        { operationId: 'update_feed', operationName: 'updateFeed' }
    );

    return customOptions;
};

export type UpdateFeedMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateFeedHook>>>>;
export type UpdateFeedMutationBody = FeedUpdate;
export type UpdateFeedMutationError = ErrorType<ErrorResponse>;
export type UpdateFeedMutationVariables = { feedId: string; data: FeedUpdate };

/**
 * @summary Update Feed
 */
export const useUpdateFeed = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateFeedHook>>>,
            TError,
            UpdateFeedMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateFeedHook>>>,
    TError,
    UpdateFeedMutationVariables,
    TContext
> => {
    return useMutation(useUpdateFeedMutationOptions(options), queryClient);
};
export const getDeleteFeedUrl = (feedId: string) => {
    return `/workspace/feeds/${feedId}`;
};

/**
 * @summary Delete Feed
 */
export const useDeleteFeedHook = (): ((
    feedId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (feedId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getDeleteFeedUrl(feedId), {
            ...options,
            method: 'DELETE',
        });
    };
};

export const getDeleteFeedMutationKey = () => ['deleteFeed'] as const;

export const useDeleteFeedMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteFeedHook>>>,
        TError,
        DeleteFeedMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteFeedHook>>>,
    TError,
    DeleteFeedMutationVariables,
    TContext
> => {
    const mutationKey = getDeleteFeedMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const deleteFeed = useDeleteFeedHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteFeedHook>>>,
        DeleteFeedMutationVariables
    > = (props) => {
        const { feedId } = props ?? {};

        return deleteFeed(feedId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feeds/{feedId}` },
        { operationId: 'delete_feed', operationName: 'deleteFeed' }
    );

    return customOptions;
};

export type DeleteFeedMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteFeedHook>>>>;

export type DeleteFeedMutationError = ErrorType<ErrorResponse>;
export type DeleteFeedMutationVariables = { feedId: string };

/**
 * @summary Delete Feed
 */
export const useDeleteFeed = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeleteFeedHook>>>,
            TError,
            DeleteFeedMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteFeedHook>>>,
    TError,
    DeleteFeedMutationVariables,
    TContext
> => {
    return useMutation(useDeleteFeedMutationOptions(options), queryClient);
};
export const getRenewFeedSecretUrl = (feedId: string) => {
    return `/workspace/feeds/${feedId}/secret`;
};

/**
 * @summary Renew Feed Secret
 */
export const useRenewFeedSecretHook = (): ((
    feedId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const customFetcher = useApiFetch();
    return (feedId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getRenewFeedSecretUrl(feedId), {
            ...options,
            method: 'POST',

            schema: Feed,
        });
    };
};

export const getRenewFeedSecretMutationKey = () => ['renewFeedSecret'] as const;

export const useRenewFeedSecretMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRenewFeedSecretHook>>>,
        TError,
        RenewFeedSecretMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRenewFeedSecretHook>>>,
    TError,
    RenewFeedSecretMutationVariables,
    TContext
> => {
    const mutationKey = getRenewFeedSecretMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const renewFeedSecret = useRenewFeedSecretHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useRenewFeedSecretHook>>>,
        RenewFeedSecretMutationVariables
    > = (props) => {
        const { feedId } = props ?? {};

        return renewFeedSecret(feedId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feeds/{feedId}/secret` },
        { operationId: 'renew_feed_secret', operationName: 'renewFeedSecret' }
    );

    return customOptions;
};

export type RenewFeedSecretMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRenewFeedSecretHook>>>>;

export type RenewFeedSecretMutationError = ErrorType<ErrorResponse>;
export type RenewFeedSecretMutationVariables = { feedId: string };

/**
 * @summary Renew Feed Secret
 */
export const useRenewFeedSecret = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useRenewFeedSecretHook>>>,
            TError,
            RenewFeedSecretMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useRenewFeedSecretHook>>>,
    TError,
    RenewFeedSecretMutationVariables,
    TContext
> => {
    return useMutation(useRenewFeedSecretMutationOptions(options), queryClient);
};
export const getRenewFeedEmailAddressUrl = (feedId: string) => {
    return `/workspace/feeds/${feedId}/email-address`;
};

/**
 * @summary Renew Feed Email Address
 */
export const useRenewFeedEmailAddressHook = (): ((
    feedId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const customFetcher = useApiFetch();
    return (feedId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getRenewFeedEmailAddressUrl(feedId), {
            ...options,
            method: 'POST',

            schema: Feed,
        });
    };
};

export const getRenewFeedEmailAddressMutationKey = () => ['renewFeedEmailAddress'] as const;

export const useRenewFeedEmailAddressMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRenewFeedEmailAddressHook>>>,
        TError,
        RenewFeedEmailAddressMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRenewFeedEmailAddressHook>>>,
    TError,
    RenewFeedEmailAddressMutationVariables,
    TContext
> => {
    const mutationKey = getRenewFeedEmailAddressMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const renewFeedEmailAddress = useRenewFeedEmailAddressHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useRenewFeedEmailAddressHook>>>,
        RenewFeedEmailAddressMutationVariables
    > = (props) => {
        const { feedId } = props ?? {};

        return renewFeedEmailAddress(feedId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feeds/{feedId}/email-address` },
        { operationId: 'renew_feed_email_address', operationName: 'renewFeedEmailAddress' }
    );

    return customOptions;
};

export type RenewFeedEmailAddressMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useRenewFeedEmailAddressHook>>>
>;

export type RenewFeedEmailAddressMutationError = ErrorType<ErrorResponse>;
export type RenewFeedEmailAddressMutationVariables = { feedId: string };

/**
 * @summary Renew Feed Email Address
 */
export const useRenewFeedEmailAddress = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useRenewFeedEmailAddressHook>>>,
            TError,
            RenewFeedEmailAddressMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useRenewFeedEmailAddressHook>>>,
    TError,
    RenewFeedEmailAddressMutationVariables,
    TContext
> => {
    return useMutation(useRenewFeedEmailAddressMutationOptions(options), queryClient);
};
export const getUpdateFeedEmailAddressUrl = (feedId: string) => {
    return `/workspace/feeds/${feedId}/email-address`;
};

/**
 * @summary Update Feed Email Address
 */
export const useUpdateFeedEmailAddressHook = (): ((
    feedId: string,
    emailAddressUpdate: EmailAddressUpdate,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (
        feedId: string,
        emailAddressUpdate: EmailAddressUpdate,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getUpdateFeedEmailAddressUrl(feedId), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(emailAddressUpdate),
            schema: Feed,
        });
    };
};

export const getUpdateFeedEmailAddressMutationKey = () => ['updateFeedEmailAddress'] as const;

export const useUpdateFeedEmailAddressMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateFeedEmailAddressHook>>>,
        TError,
        UpdateFeedEmailAddressMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateFeedEmailAddressHook>>>,
    TError,
    UpdateFeedEmailAddressMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateFeedEmailAddressMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateFeedEmailAddress = useUpdateFeedEmailAddressHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateFeedEmailAddressHook>>>,
        UpdateFeedEmailAddressMutationVariables
    > = (props) => {
        const { feedId, data } = props ?? {};

        return updateFeedEmailAddress(feedId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feeds/{feedId}/email-address` },
        { operationId: 'update_feed_email_address', operationName: 'updateFeedEmailAddress' }
    );

    return customOptions;
};

export type UpdateFeedEmailAddressMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateFeedEmailAddressHook>>>
>;
export type UpdateFeedEmailAddressMutationBody = EmailAddressUpdate;
export type UpdateFeedEmailAddressMutationError = ErrorType<ErrorResponse>;
export type UpdateFeedEmailAddressMutationVariables = { feedId: string; data: EmailAddressUpdate };

/**
 * @summary Update Feed Email Address
 */
export const useUpdateFeedEmailAddress = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateFeedEmailAddressHook>>>,
            TError,
            UpdateFeedEmailAddressMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateFeedEmailAddressHook>>>,
    TError,
    UpdateFeedEmailAddressMutationVariables,
    TContext
> => {
    return useMutation(useUpdateFeedEmailAddressMutationOptions(options), queryClient);
};
export const getCreateRouteUrl = (feedId: string) => {
    return `/workspace/feeds/${feedId}/routes`;
};

/**
 * @summary Create Route
 */
export const useCreateRouteHook = (): ((
    feedId: string,
    feedRouteInput: FeedRouteInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<FeedRoute>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (
        feedId: string,
        feedRouteInput: FeedRouteInput,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getCreateRouteUrl(feedId), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(feedRouteInput),
            schema: FeedRoute,
        });
    };
};

export const getCreateRouteMutationKey = () => ['createRoute'] as const;

export const useCreateRouteMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateRouteHook>>>,
        TError,
        CreateRouteMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateRouteHook>>>,
    TError,
    CreateRouteMutationVariables,
    TContext
> => {
    const mutationKey = getCreateRouteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const createRoute = useCreateRouteHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateRouteHook>>>,
        CreateRouteMutationVariables
    > = (props) => {
        const { feedId, data } = props ?? {};

        return createRoute(feedId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feeds/{feedId}/routes` },
        { operationId: 'create_route', operationName: 'createRoute' }
    );

    return customOptions;
};

export type CreateRouteMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateRouteHook>>>>;
export type CreateRouteMutationBody = FeedRouteInput;
export type CreateRouteMutationError = ErrorType<ErrorResponse>;
export type CreateRouteMutationVariables = { feedId: string; data: FeedRouteInput };

/**
 * @summary Create Route
 */
export const useCreateRoute = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateRouteHook>>>,
            TError,
            CreateRouteMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateRouteHook>>>,
    TError,
    CreateRouteMutationVariables,
    TContext
> => {
    return useMutation(useCreateRouteMutationOptions(options), queryClient);
};
export const getUpdateRouteUrl = (routeId: string) => {
    return `/workspace/feed-routes/${routeId}`;
};

/**
 * @summary Update Route
 */
export const useUpdateRouteHook = (): ((
    routeId: string,
    feedRouteUpdate: FeedRouteUpdate,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<FeedRoute>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (
        routeId: string,
        feedRouteUpdate: FeedRouteUpdate,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getUpdateRouteUrl(routeId), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(feedRouteUpdate),
            schema: FeedRoute,
        });
    };
};

export const getUpdateRouteMutationKey = () => ['updateRoute'] as const;

export const useUpdateRouteMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateRouteHook>>>,
        TError,
        UpdateRouteMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateRouteHook>>>,
    TError,
    UpdateRouteMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateRouteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateRoute = useUpdateRouteHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateRouteHook>>>,
        UpdateRouteMutationVariables
    > = (props) => {
        const { routeId, data } = props ?? {};

        return updateRoute(routeId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feed-routes/{routeId}` },
        { operationId: 'update_route', operationName: 'updateRoute' }
    );

    return customOptions;
};

export type UpdateRouteMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateRouteHook>>>>;
export type UpdateRouteMutationBody = FeedRouteUpdate;
export type UpdateRouteMutationError = ErrorType<ErrorResponse>;
export type UpdateRouteMutationVariables = { routeId: string; data: FeedRouteUpdate };

/**
 * @summary Update Route
 */
export const useUpdateRoute = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateRouteHook>>>,
            TError,
            UpdateRouteMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateRouteHook>>>,
    TError,
    UpdateRouteMutationVariables,
    TContext
> => {
    return useMutation(useUpdateRouteMutationOptions(options), queryClient);
};
export const getDeleteRouteUrl = (routeId: string) => {
    return `/workspace/feed-routes/${routeId}`;
};

/**
 * @summary Delete Route
 */
export const useDeleteRouteHook = (): ((
    routeId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (routeId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getDeleteRouteUrl(routeId), {
            ...options,
            method: 'DELETE',
        });
    };
};

export const getDeleteRouteMutationKey = () => ['deleteRoute'] as const;

export const useDeleteRouteMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteRouteHook>>>,
        TError,
        DeleteRouteMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteRouteHook>>>,
    TError,
    DeleteRouteMutationVariables,
    TContext
> => {
    const mutationKey = getDeleteRouteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const deleteRoute = useDeleteRouteHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteRouteHook>>>,
        DeleteRouteMutationVariables
    > = (props) => {
        const { routeId } = props ?? {};

        return deleteRoute(routeId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feed-routes/{routeId}` },
        { operationId: 'delete_route', operationName: 'deleteRoute' }
    );

    return customOptions;
};

export type DeleteRouteMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteRouteHook>>>>;

export type DeleteRouteMutationError = ErrorType<ErrorResponse>;
export type DeleteRouteMutationVariables = { routeId: string };

/**
 * @summary Delete Route
 */
export const useDeleteRoute = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeleteRouteHook>>>,
            TError,
            DeleteRouteMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteRouteHook>>>,
    TError,
    DeleteRouteMutationVariables,
    TContext
> => {
    return useMutation(useDeleteRouteMutationOptions(options), queryClient);
};
export const getPreviewRouteUrl = (feedId: string) => {
    return `/workspace/feeds/${feedId}/routes/preview`;
};

/**
 * @summary Preview Route
 */
export const usePreviewRouteHook = (): ((
    feedId: string,
    routePreviewInput: RoutePreviewInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<RoutePreview>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (
        feedId: string,
        routePreviewInput: RoutePreviewInput,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getPreviewRouteUrl(feedId), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(routePreviewInput),
            schema: RoutePreview,
        });
    };
};

export const getPreviewRouteMutationKey = () => ['previewRoute'] as const;

export const usePreviewRouteMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePreviewRouteHook>>>,
        TError,
        PreviewRouteMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePreviewRouteHook>>>,
    TError,
    PreviewRouteMutationVariables,
    TContext
> => {
    const mutationKey = getPreviewRouteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const previewRoute = usePreviewRouteHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePreviewRouteHook>>>,
        PreviewRouteMutationVariables
    > = (props) => {
        const { feedId, data } = props ?? {};

        return previewRoute(feedId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feeds/{feedId}/routes/preview` },
        { operationId: 'preview_route', operationName: 'previewRoute' }
    );

    return customOptions;
};

export type PreviewRouteMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePreviewRouteHook>>>>;
export type PreviewRouteMutationBody = RoutePreviewInput;
export type PreviewRouteMutationError = ErrorType<ErrorResponse>;
export type PreviewRouteMutationVariables = { feedId: string; data: RoutePreviewInput };

/**
 * @summary Preview Route
 */
export const usePreviewRoute = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof usePreviewRouteHook>>>,
            TError,
            PreviewRouteMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePreviewRouteHook>>>,
    TError,
    PreviewRouteMutationVariables,
    TContext
> => {
    return useMutation(usePreviewRouteMutationOptions(options), queryClient);
};
export const getListExternalCompaniesUrl = (params?: ListExternalCompaniesParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/workspace/external-companies?${stringifiedParams}`
        : `/workspace/external-companies`;
};

/**
 * @summary List External Companies
 */
export const useListExternalCompaniesHook = (): ((
    params?: ListExternalCompaniesParams,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<PagedExternalCompany>) => {
    const customFetcher = useApiFetch();
    return (params?: ListExternalCompaniesParams, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListExternalCompaniesUrl(params), {
            ...options,
            method: 'GET',

            schema: PagedExternalCompany,
        });
    };
};

export const getListExternalCompaniesQueryKey = (params?: ListExternalCompaniesParams) => {
    return ['workspace', 'external-companies', ...(params ? [params] : [])] as const;
};

export const useListExternalCompaniesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    params?: ListExternalCompaniesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListExternalCompaniesQueryKey(params);

    const listExternalCompanies = useListExternalCompaniesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>> = ({ signal }) =>
        listExternalCompanies(params, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        { params },
        {
            url: `/workspace/external-companies`,
            operationId: 'list_external_companies',
            operationName: 'listExternalCompanies',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExternalCompaniesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>
>;
export type ListExternalCompaniesQueryError = ErrorType<ErrorResponse>;

export function useListExternalCompanies<
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    params: undefined | ListExternalCompaniesParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListExternalCompanies<
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    params?: ListExternalCompaniesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListExternalCompanies<
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    params?: ListExternalCompaniesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List External Companies
 */

export function useListExternalCompanies<
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    params?: ListExternalCompaniesParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalCompaniesHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListExternalCompaniesQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateClientFromExternalCompanyUrl = (companyId: string) => {
    return `/workspace/external-companies/${companyId}/client`;
};

/**
 * @summary Create Client From External Company
 */
export const useCreateClientFromExternalCompanyHook = (): ((
    companyId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<ExternalCompany>) => {
    const customFetcher = useApiFetch();
    return (companyId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getCreateClientFromExternalCompanyUrl(companyId), {
            ...options,
            method: 'POST',

            schema: ExternalCompany,
        });
    };
};

export const getCreateClientFromExternalCompanyMutationKey = () => ['createClientFromExternalCompany'] as const;

export const useCreateClientFromExternalCompanyMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateClientFromExternalCompanyHook>>>,
        TError,
        CreateClientFromExternalCompanyMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateClientFromExternalCompanyHook>>>,
    TError,
    CreateClientFromExternalCompanyMutationVariables,
    TContext
> => {
    const mutationKey = getCreateClientFromExternalCompanyMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const createClientFromExternalCompany = useCreateClientFromExternalCompanyHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateClientFromExternalCompanyHook>>>,
        CreateClientFromExternalCompanyMutationVariables
    > = (props) => {
        const { companyId } = props ?? {};

        return createClientFromExternalCompany(companyId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/external-companies/{companyId}/client` },
        { operationId: 'create_client_from_external_company', operationName: 'createClientFromExternalCompany' }
    );

    return customOptions;
};

export type CreateClientFromExternalCompanyMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateClientFromExternalCompanyHook>>>
>;

export type CreateClientFromExternalCompanyMutationError = ErrorType<ErrorResponse>;
export type CreateClientFromExternalCompanyMutationVariables = { companyId: string };

/**
 * @summary Create Client From External Company
 */
export const useCreateClientFromExternalCompany = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateClientFromExternalCompanyHook>>>,
            TError,
            CreateClientFromExternalCompanyMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateClientFromExternalCompanyHook>>>,
    TError,
    CreateClientFromExternalCompanyMutationVariables,
    TContext
> => {
    return useMutation(useCreateClientFromExternalCompanyMutationOptions(options), queryClient);
};
export const getUpdateExternalCompanyUrl = (companyId: string) => {
    return `/workspace/external-companies/${companyId}`;
};

/**
 * @summary Update External Company
 */
export const useUpdateExternalCompanyHook = (): ((
    companyId: string,
    externalCompanyUpdate: ExternalCompanyUpdate,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<ExternalCompany>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (
        companyId: string,
        externalCompanyUpdate: ExternalCompanyUpdate,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getUpdateExternalCompanyUrl(companyId), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(externalCompanyUpdate),
            schema: ExternalCompany,
        });
    };
};

export const getUpdateExternalCompanyMutationKey = () => ['updateExternalCompany'] as const;

export const useUpdateExternalCompanyMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateExternalCompanyHook>>>,
        TError,
        UpdateExternalCompanyMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateExternalCompanyHook>>>,
    TError,
    UpdateExternalCompanyMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateExternalCompanyMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateExternalCompany = useUpdateExternalCompanyHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateExternalCompanyHook>>>,
        UpdateExternalCompanyMutationVariables
    > = (props) => {
        const { companyId, data } = props ?? {};

        return updateExternalCompany(companyId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/external-companies/{companyId}` },
        { operationId: 'update_external_company', operationName: 'updateExternalCompany' }
    );

    return customOptions;
};

export type UpdateExternalCompanyMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateExternalCompanyHook>>>
>;
export type UpdateExternalCompanyMutationBody = ExternalCompanyUpdate;
export type UpdateExternalCompanyMutationError = ErrorType<ErrorResponse>;
export type UpdateExternalCompanyMutationVariables = { companyId: string; data: ExternalCompanyUpdate };

/**
 * @summary Update External Company
 */
export const useUpdateExternalCompany = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateExternalCompanyHook>>>,
            TError,
            UpdateExternalCompanyMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateExternalCompanyHook>>>,
    TError,
    UpdateExternalCompanyMutationVariables,
    TContext
> => {
    return useMutation(useUpdateExternalCompanyMutationOptions(options), queryClient);
};
export const getListExternalContactsUrl = (clientId: string | null) => {
    return `/workspace/clients/${clientId}/external-contacts`;
};

/**
 * @summary List External Contacts
 */
export const useListExternalContactsHook = (): ((
    clientId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<ExternalContact[]>) => {
    const customFetcher = useApiFetch();
    return (clientId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListExternalContactsUrl(clientId), {
            ...options,
            method: 'GET',

            schema: zod.array(ExternalContact),
        });
    };
};

export const getListExternalContactsQueryKey = (clientId: string | null) => {
    return ['workspace', 'clients', clientId, 'external-contacts'] as const;
};

export const useListExternalContactsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    clientId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListExternalContactsQueryKey(clientId);

    const listExternalContacts = useListExternalContactsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>> = ({ signal }) =>
        listExternalContacts(clientId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions },
        { clientId },
        {
            url: `/workspace/clients/${clientId}/external-contacts`,
            operationId: 'list_external_contacts',
            operationName: 'listExternalContacts',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListExternalContactsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>
>;
export type ListExternalContactsQueryError = ErrorType<ErrorResponse>;

export function useListExternalContacts<
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    clientId: string | null,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListExternalContacts<
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    clientId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListExternalContacts<
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    clientId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List External Contacts
 */

export function useListExternalContacts<
    TData = Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    clientId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListExternalContactsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListExternalContactsQueryOptions(clientId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getSyncFeedsUrl = () => {
    return `/workspace/feeds/sync`;
};

/**
 * @summary Sync Feeds
 */
export const useSyncFeedsHook = (): ((options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => Promise<Feed[]>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getSyncFeedsUrl(), {
            ...options,
            method: 'POST',

            schema: zod.array(Feed),
        });
    };
};

export const getSyncFeedsMutationKey = () => ['syncFeeds'] as const;

export const useSyncFeedsMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSyncFeedsHook>>>, TError, void, TContext>;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSyncFeedsHook>>>, TError, void, TContext> => {
    const mutationKey = getSyncFeedsMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const syncFeeds = useSyncFeedsHook();

    const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useSyncFeedsHook>>>, void> = () => {
        return syncFeeds(requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feeds/sync` },
        { operationId: 'sync_feeds', operationName: 'syncFeeds' }
    );

    return customOptions;
};

export type SyncFeedsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSyncFeedsHook>>>>;

export type SyncFeedsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Sync Feeds
 */
export const useSyncFeeds = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useSyncFeedsHook>>>, TError, void, TContext>;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useSyncFeedsHook>>>, TError, void, TContext> => {
    return useMutation(useSyncFeedsMutationOptions(options), queryClient);
};
export const getSyncFeedUrl = (feedId: string) => {
    return `/workspace/feeds/${feedId}/sync`;
};

/**
 * @summary Sync Feed
 */
export const useSyncFeedHook = (): ((
    feedId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const customFetcher = useApiFetch();
    return (feedId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getSyncFeedUrl(feedId), {
            ...options,
            method: 'POST',

            schema: Feed,
        });
    };
};

export const getSyncFeedMutationKey = () => ['syncFeed'] as const;

export const useSyncFeedMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSyncFeedHook>>>,
        TError,
        SyncFeedMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSyncFeedHook>>>,
    TError,
    SyncFeedMutationVariables,
    TContext
> => {
    const mutationKey = getSyncFeedMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const syncFeed = useSyncFeedHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSyncFeedHook>>>,
        SyncFeedMutationVariables
    > = (props) => {
        const { feedId } = props ?? {};

        return syncFeed(feedId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/feeds/{feedId}/sync` },
        { operationId: 'sync_feed', operationName: 'syncFeed' }
    );

    return customOptions;
};

export type SyncFeedMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSyncFeedHook>>>>;

export type SyncFeedMutationError = ErrorType<ErrorResponse>;
export type SyncFeedMutationVariables = { feedId: string };

/**
 * @summary Sync Feed
 */
export const useSyncFeed = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useSyncFeedHook>>>,
            TError,
            SyncFeedMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useSyncFeedHook>>>,
    TError,
    SyncFeedMutationVariables,
    TContext
> => {
    return useMutation(useSyncFeedMutationOptions(options), queryClient);
};
export const getListEmployeeProvidersUrl = () => {
    return `/workspace/client/integrations/providers`;
};

/**
 * @summary List Employee Providers
 */
export const useListEmployeeProvidersHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Provider[]>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListEmployeeProvidersUrl(), {
            ...options,
            method: 'GET',

            schema: zod.array(Provider),
        });
    };
};

export const getListEmployeeProvidersQueryKey = () => {
    return ['workspace', 'client', 'integrations', 'providers'] as const;
};

export const useListEmployeeProvidersQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListEmployeeProvidersQueryKey();

    const listEmployeeProviders = useListEmployeeProvidersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>> = ({ signal }) =>
        listEmployeeProviders({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        {
            url: `/workspace/client/integrations/providers`,
            operationId: 'list_employee_providers',
            operationName: 'listEmployeeProviders',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEmployeeProvidersQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>
>;
export type ListEmployeeProvidersQueryError = ErrorType<ErrorResponse>;

export function useListEmployeeProviders<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEmployeeProviders<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEmployeeProviders<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Employee Providers
 */

export function useListEmployeeProviders<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeProvidersHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListEmployeeProvidersQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getListEmployeeConnectionsUrl = () => {
    return `/workspace/client/connections`;
};

/**
 * @summary List Employee Connections
 */
export const useListEmployeeConnectionsHook = (): ((
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Connection[]>) => {
    const customFetcher = useApiFetch();
    return (options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListEmployeeConnectionsUrl(), {
            ...options,
            method: 'GET',

            schema: zod.array(Connection),
        });
    };
};

export const getListEmployeeConnectionsQueryKey = () => {
    return ['workspace', 'client', 'connections'] as const;
};

export const useListEmployeeConnectionsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>, TError, TData>
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListEmployeeConnectionsQueryKey();

    const listEmployeeConnections = useListEmployeeConnectionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>> = ({
        signal,
    }) => listEmployeeConnections({ signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, ...queryOptions },
        {},
        {
            url: `/workspace/client/connections`,
            operationId: 'list_employee_connections',
            operationName: 'listEmployeeConnections',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEmployeeConnectionsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>
>;
export type ListEmployeeConnectionsQueryError = ErrorType<ErrorResponse>;

export function useListEmployeeConnections<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEmployeeConnections<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEmployeeConnections<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Employee Connections
 */

export function useListEmployeeConnections<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeConnectionsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListEmployeeConnectionsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateEmployeeConnectionUrl = () => {
    return `/workspace/client/connections`;
};

/**
 * @summary Create Employee Connection
 */
export const useCreateEmployeeConnectionHook = (): ((
    connectionInput: ConnectionInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<ConnectionCreated>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (connectionInput: ConnectionInput, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getCreateEmployeeConnectionUrl(), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(connectionInput),
            schema: ConnectionCreated,
        });
    };
};

export const getCreateEmployeeConnectionMutationKey = () => ['createEmployeeConnection'] as const;

export const useCreateEmployeeConnectionMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateEmployeeConnectionHook>>>,
        TError,
        CreateEmployeeConnectionMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateEmployeeConnectionHook>>>,
    TError,
    CreateEmployeeConnectionMutationVariables,
    TContext
> => {
    const mutationKey = getCreateEmployeeConnectionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const createEmployeeConnection = useCreateEmployeeConnectionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateEmployeeConnectionHook>>>,
        CreateEmployeeConnectionMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return createEmployeeConnection(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/connections` },
        { operationId: 'create_employee_connection', operationName: 'createEmployeeConnection' }
    );

    return customOptions;
};

export type CreateEmployeeConnectionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateEmployeeConnectionHook>>>
>;
export type CreateEmployeeConnectionMutationBody = ConnectionInput;
export type CreateEmployeeConnectionMutationError = ErrorType<ErrorResponse>;
export type CreateEmployeeConnectionMutationVariables = { data: ConnectionInput };

/**
 * @summary Create Employee Connection
 */
export const useCreateEmployeeConnection = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateEmployeeConnectionHook>>>,
            TError,
            CreateEmployeeConnectionMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateEmployeeConnectionHook>>>,
    TError,
    CreateEmployeeConnectionMutationVariables,
    TContext
> => {
    return useMutation(useCreateEmployeeConnectionMutationOptions(options), queryClient);
};
export const getStartEmployeeOauthUrl = () => {
    return `/workspace/client/connections/oauth`;
};

/**
 * @summary Start Employee Oauth
 */
export const useStartEmployeeOauthHook = (): ((
    oAuthStart: OAuthStart,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<OAuthStartResult>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (oAuthStart: OAuthStart, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getStartEmployeeOauthUrl(), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(oAuthStart),
            schema: OAuthStartResult,
        });
    };
};

export const getStartEmployeeOauthMutationKey = () => ['startEmployeeOauth'] as const;

export const useStartEmployeeOauthMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useStartEmployeeOauthHook>>>,
        TError,
        StartEmployeeOauthMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useStartEmployeeOauthHook>>>,
    TError,
    StartEmployeeOauthMutationVariables,
    TContext
> => {
    const mutationKey = getStartEmployeeOauthMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const startEmployeeOauth = useStartEmployeeOauthHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useStartEmployeeOauthHook>>>,
        StartEmployeeOauthMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return startEmployeeOauth(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/connections/oauth` },
        { operationId: 'start_employee_oauth', operationName: 'startEmployeeOauth' }
    );

    return customOptions;
};

export type StartEmployeeOauthMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useStartEmployeeOauthHook>>>
>;
export type StartEmployeeOauthMutationBody = OAuthStart;
export type StartEmployeeOauthMutationError = ErrorType<ErrorResponse>;
export type StartEmployeeOauthMutationVariables = { data: OAuthStart };

/**
 * @summary Start Employee Oauth
 */
export const useStartEmployeeOauth = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useStartEmployeeOauthHook>>>,
            TError,
            StartEmployeeOauthMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useStartEmployeeOauthHook>>>,
    TError,
    StartEmployeeOauthMutationVariables,
    TContext
> => {
    return useMutation(useStartEmployeeOauthMutationOptions(options), queryClient);
};
export const getUpdateEmployeeConnectionUrl = (connectionId: string) => {
    return `/workspace/client/connections/${connectionId}`;
};

/**
 * @summary Update Employee Connection
 */
export const useUpdateEmployeeConnectionHook = (): ((
    connectionId: string,
    connectionUpdate: ConnectionUpdate,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Connection>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (
        connectionId: string,
        connectionUpdate: ConnectionUpdate,
        options?: Parameters<ReturnType<typeof useApiFetch>>[1]
    ) => {
        return customFetcher(getUpdateEmployeeConnectionUrl(connectionId), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(connectionUpdate),
            schema: Connection,
        });
    };
};

export const getUpdateEmployeeConnectionMutationKey = () => ['updateEmployeeConnection'] as const;

export const useUpdateEmployeeConnectionMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeConnectionHook>>>,
        TError,
        UpdateEmployeeConnectionMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeConnectionHook>>>,
    TError,
    UpdateEmployeeConnectionMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateEmployeeConnectionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateEmployeeConnection = useUpdateEmployeeConnectionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeConnectionHook>>>,
        UpdateEmployeeConnectionMutationVariables
    > = (props) => {
        const { connectionId, data } = props ?? {};

        return updateEmployeeConnection(connectionId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/connections/{connectionId}` },
        { operationId: 'update_employee_connection', operationName: 'updateEmployeeConnection' }
    );

    return customOptions;
};

export type UpdateEmployeeConnectionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeConnectionHook>>>
>;
export type UpdateEmployeeConnectionMutationBody = ConnectionUpdate;
export type UpdateEmployeeConnectionMutationError = ErrorType<ErrorResponse>;
export type UpdateEmployeeConnectionMutationVariables = { connectionId: string; data: ConnectionUpdate };

/**
 * @summary Update Employee Connection
 */
export const useUpdateEmployeeConnection = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeConnectionHook>>>,
            TError,
            UpdateEmployeeConnectionMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeConnectionHook>>>,
    TError,
    UpdateEmployeeConnectionMutationVariables,
    TContext
> => {
    return useMutation(useUpdateEmployeeConnectionMutationOptions(options), queryClient);
};
export const getDeleteEmployeeConnectionUrl = (connectionId: string) => {
    return `/workspace/client/connections/${connectionId}`;
};

/**
 * @summary Delete Employee Connection
 */
export const useDeleteEmployeeConnectionHook = (): ((
    connectionId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getDeleteEmployeeConnectionUrl(connectionId), {
            ...options,
            method: 'DELETE',
        });
    };
};

export const getDeleteEmployeeConnectionMutationKey = () => ['deleteEmployeeConnection'] as const;

export const useDeleteEmployeeConnectionMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeConnectionHook>>>,
        TError,
        DeleteEmployeeConnectionMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeConnectionHook>>>,
    TError,
    DeleteEmployeeConnectionMutationVariables,
    TContext
> => {
    const mutationKey = getDeleteEmployeeConnectionMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const deleteEmployeeConnection = useDeleteEmployeeConnectionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeConnectionHook>>>,
        DeleteEmployeeConnectionMutationVariables
    > = (props) => {
        const { connectionId } = props ?? {};

        return deleteEmployeeConnection(connectionId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/connections/{connectionId}` },
        { operationId: 'delete_employee_connection', operationName: 'deleteEmployeeConnection' }
    );

    return customOptions;
};

export type DeleteEmployeeConnectionMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeConnectionHook>>>
>;

export type DeleteEmployeeConnectionMutationError = ErrorType<ErrorResponse>;
export type DeleteEmployeeConnectionMutationVariables = { connectionId: string };

/**
 * @summary Delete Employee Connection
 */
export const useDeleteEmployeeConnection = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeConnectionHook>>>,
            TError,
            DeleteEmployeeConnectionMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeConnectionHook>>>,
    TError,
    DeleteEmployeeConnectionMutationVariables,
    TContext
> => {
    return useMutation(useDeleteEmployeeConnectionMutationOptions(options), queryClient);
};
export const getRenewEmployeeConnectionTokenUrl = (connectionId: string) => {
    return `/workspace/client/connections/${connectionId}/token`;
};

/**
 * @summary Renew Employee Connection Token
 */
export const useRenewEmployeeConnectionTokenHook = (): ((
    connectionId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<ConnectionToken>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getRenewEmployeeConnectionTokenUrl(connectionId), {
            ...options,
            method: 'POST',

            schema: ConnectionToken,
        });
    };
};

export const getRenewEmployeeConnectionTokenMutationKey = () => ['renewEmployeeConnectionToken'] as const;

export const useRenewEmployeeConnectionTokenMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRenewEmployeeConnectionTokenHook>>>,
        TError,
        RenewEmployeeConnectionTokenMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRenewEmployeeConnectionTokenHook>>>,
    TError,
    RenewEmployeeConnectionTokenMutationVariables,
    TContext
> => {
    const mutationKey = getRenewEmployeeConnectionTokenMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const renewEmployeeConnectionToken = useRenewEmployeeConnectionTokenHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useRenewEmployeeConnectionTokenHook>>>,
        RenewEmployeeConnectionTokenMutationVariables
    > = (props) => {
        const { connectionId } = props ?? {};

        return renewEmployeeConnectionToken(connectionId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/connections/{connectionId}/token` },
        { operationId: 'renew_employee_connection_token', operationName: 'renewEmployeeConnectionToken' }
    );

    return customOptions;
};

export type RenewEmployeeConnectionTokenMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useRenewEmployeeConnectionTokenHook>>>
>;

export type RenewEmployeeConnectionTokenMutationError = ErrorType<ErrorResponse>;
export type RenewEmployeeConnectionTokenMutationVariables = { connectionId: string };

/**
 * @summary Renew Employee Connection Token
 */
export const useRenewEmployeeConnectionToken = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useRenewEmployeeConnectionTokenHook>>>,
            TError,
            RenewEmployeeConnectionTokenMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useRenewEmployeeConnectionTokenHook>>>,
    TError,
    RenewEmployeeConnectionTokenMutationVariables,
    TContext
> => {
    return useMutation(useRenewEmployeeConnectionTokenMutationOptions(options), queryClient);
};
export const getListEmployeeTodoListsUrl = (connectionId: string | null) => {
    return `/workspace/client/connections/${connectionId}/todo-lists`;
};

/**
 * @summary List Employee Todo Lists
 */
export const useListEmployeeTodoListsHook = (): ((
    connectionId: string | null,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<TodoList[]>) => {
    const customFetcher = useApiFetch();
    return (connectionId: string | null, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getListEmployeeTodoListsUrl(connectionId), {
            ...options,
            method: 'GET',

            schema: zod.array(TodoList),
        });
    };
};

export const getListEmployeeTodoListsQueryKey = (connectionId: string | null) => {
    return ['workspace', 'client', 'connections', connectionId, 'todo-lists'] as const;
};

export const useListEmployeeTodoListsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    }
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getListEmployeeTodoListsQueryKey(connectionId);

    const listEmployeeTodoLists = useListEmployeeTodoListsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>> = ({ signal }) =>
        listEmployeeTodoLists(connectionId, { signal, ...requestOptions });

    const customOptions = useQueryBehavior(
        { queryKey, queryFn, enabled: connectionId !== null && connectionId !== undefined, ...queryOptions },
        { connectionId },
        {
            url: `/workspace/client/connections/${connectionId}/todo-lists`,
            operationId: 'list_employee_todo_lists',
            operationName: 'listEmployeeTodoLists',
        }
    );

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEmployeeTodoListsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>
>;
export type ListEmployeeTodoListsQueryError = ErrorType<ErrorResponse>;

export function useListEmployeeTodoLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEmployeeTodoLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>
                >,
                'initialData'
            >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListEmployeeTodoLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Employee Todo Lists
 */

export function useListEmployeeTodoLists<
    TData = Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>,
    TError = ErrorType<ErrorResponse>,
>(
    connectionId: string | null,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListEmployeeTodoListsHook>>>, TError, TData>
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useListEmployeeTodoListsQueryOptions(connectionId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateEmployeeFeedUrl = (connectionId: string) => {
    return `/workspace/client/connections/${connectionId}/feeds`;
};

/**
 * @summary Create Employee Feed
 */
export const useCreateEmployeeFeedHook = (): ((
    connectionId: string,
    feedInput: FeedInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (connectionId: string, feedInput: FeedInput, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getCreateEmployeeFeedUrl(connectionId), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(feedInput),
            schema: Feed,
        });
    };
};

export const getCreateEmployeeFeedMutationKey = () => ['createEmployeeFeed'] as const;

export const useCreateEmployeeFeedMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateEmployeeFeedHook>>>,
        TError,
        CreateEmployeeFeedMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateEmployeeFeedHook>>>,
    TError,
    CreateEmployeeFeedMutationVariables,
    TContext
> => {
    const mutationKey = getCreateEmployeeFeedMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const createEmployeeFeed = useCreateEmployeeFeedHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateEmployeeFeedHook>>>,
        CreateEmployeeFeedMutationVariables
    > = (props) => {
        const { connectionId, data } = props ?? {};

        return createEmployeeFeed(connectionId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/connections/{connectionId}/feeds` },
        { operationId: 'create_employee_feed', operationName: 'createEmployeeFeed' }
    );

    return customOptions;
};

export type CreateEmployeeFeedMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateEmployeeFeedHook>>>
>;
export type CreateEmployeeFeedMutationBody = FeedInput;
export type CreateEmployeeFeedMutationError = ErrorType<ErrorResponse>;
export type CreateEmployeeFeedMutationVariables = { connectionId: string; data: FeedInput };

/**
 * @summary Create Employee Feed
 */
export const useCreateEmployeeFeed = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateEmployeeFeedHook>>>,
            TError,
            CreateEmployeeFeedMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateEmployeeFeedHook>>>,
    TError,
    CreateEmployeeFeedMutationVariables,
    TContext
> => {
    return useMutation(useCreateEmployeeFeedMutationOptions(options), queryClient);
};
export const getUpdateEmployeeFeedUrl = (feedId: string) => {
    return `/workspace/client/feeds/${feedId}`;
};

/**
 * @summary Update Employee Feed
 */
export const useUpdateEmployeeFeedHook = (): ((
    feedId: string,
    feedUpdate: FeedUpdate,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (feedId: string, feedUpdate: FeedUpdate, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getUpdateEmployeeFeedUrl(feedId), {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(feedUpdate),
            schema: Feed,
        });
    };
};

export const getUpdateEmployeeFeedMutationKey = () => ['updateEmployeeFeed'] as const;

export const useUpdateEmployeeFeedMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeFeedHook>>>,
        TError,
        UpdateEmployeeFeedMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeFeedHook>>>,
    TError,
    UpdateEmployeeFeedMutationVariables,
    TContext
> => {
    const mutationKey = getUpdateEmployeeFeedMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const updateEmployeeFeed = useUpdateEmployeeFeedHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeFeedHook>>>,
        UpdateEmployeeFeedMutationVariables
    > = (props) => {
        const { feedId, data } = props ?? {};

        return updateEmployeeFeed(feedId, data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/feeds/{feedId}` },
        { operationId: 'update_employee_feed', operationName: 'updateEmployeeFeed' }
    );

    return customOptions;
};

export type UpdateEmployeeFeedMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeFeedHook>>>
>;
export type UpdateEmployeeFeedMutationBody = FeedUpdate;
export type UpdateEmployeeFeedMutationError = ErrorType<ErrorResponse>;
export type UpdateEmployeeFeedMutationVariables = { feedId: string; data: FeedUpdate };

/**
 * @summary Update Employee Feed
 */
export const useUpdateEmployeeFeed = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeFeedHook>>>,
            TError,
            UpdateEmployeeFeedMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateEmployeeFeedHook>>>,
    TError,
    UpdateEmployeeFeedMutationVariables,
    TContext
> => {
    return useMutation(useUpdateEmployeeFeedMutationOptions(options), queryClient);
};
export const getDeleteEmployeeFeedUrl = (feedId: string) => {
    return `/workspace/client/feeds/${feedId}`;
};

/**
 * @summary Delete Employee Feed
 */
export const useDeleteEmployeeFeedHook = (): ((
    feedId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const customFetcher = useApiFetch();
    return (feedId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getDeleteEmployeeFeedUrl(feedId), {
            ...options,
            method: 'DELETE',
        });
    };
};

export const getDeleteEmployeeFeedMutationKey = () => ['deleteEmployeeFeed'] as const;

export const useDeleteEmployeeFeedMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeFeedHook>>>,
        TError,
        DeleteEmployeeFeedMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeFeedHook>>>,
    TError,
    DeleteEmployeeFeedMutationVariables,
    TContext
> => {
    const mutationKey = getDeleteEmployeeFeedMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const deleteEmployeeFeed = useDeleteEmployeeFeedHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeFeedHook>>>,
        DeleteEmployeeFeedMutationVariables
    > = (props) => {
        const { feedId } = props ?? {};

        return deleteEmployeeFeed(feedId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/feeds/{feedId}` },
        { operationId: 'delete_employee_feed', operationName: 'deleteEmployeeFeed' }
    );

    return customOptions;
};

export type DeleteEmployeeFeedMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeFeedHook>>>
>;

export type DeleteEmployeeFeedMutationError = ErrorType<ErrorResponse>;
export type DeleteEmployeeFeedMutationVariables = { feedId: string };

/**
 * @summary Delete Employee Feed
 */
export const useDeleteEmployeeFeed = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeFeedHook>>>,
            TError,
            DeleteEmployeeFeedMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteEmployeeFeedHook>>>,
    TError,
    DeleteEmployeeFeedMutationVariables,
    TContext
> => {
    return useMutation(useDeleteEmployeeFeedMutationOptions(options), queryClient);
};
export const getRenewEmployeeFeedSecretUrl = (feedId: string) => {
    return `/workspace/client/feeds/${feedId}/secret`;
};

/**
 * @summary Renew Employee Feed Secret
 */
export const useRenewEmployeeFeedSecretHook = (): ((
    feedId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const customFetcher = useApiFetch();
    return (feedId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getRenewEmployeeFeedSecretUrl(feedId), {
            ...options,
            method: 'POST',

            schema: Feed,
        });
    };
};

export const getRenewEmployeeFeedSecretMutationKey = () => ['renewEmployeeFeedSecret'] as const;

export const useRenewEmployeeFeedSecretMutationOptions = <
    TError = ErrorType<ErrorResponse>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useRenewEmployeeFeedSecretHook>>>,
        TError,
        RenewEmployeeFeedSecretMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRenewEmployeeFeedSecretHook>>>,
    TError,
    RenewEmployeeFeedSecretMutationVariables,
    TContext
> => {
    const mutationKey = getRenewEmployeeFeedSecretMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const renewEmployeeFeedSecret = useRenewEmployeeFeedSecretHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useRenewEmployeeFeedSecretHook>>>,
        RenewEmployeeFeedSecretMutationVariables
    > = (props) => {
        const { feedId } = props ?? {};

        return renewEmployeeFeedSecret(feedId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/feeds/{feedId}/secret` },
        { operationId: 'renew_employee_feed_secret', operationName: 'renewEmployeeFeedSecret' }
    );

    return customOptions;
};

export type RenewEmployeeFeedSecretMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useRenewEmployeeFeedSecretHook>>>
>;

export type RenewEmployeeFeedSecretMutationError = ErrorType<ErrorResponse>;
export type RenewEmployeeFeedSecretMutationVariables = { feedId: string };

/**
 * @summary Renew Employee Feed Secret
 */
export const useRenewEmployeeFeedSecret = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useRenewEmployeeFeedSecretHook>>>,
            TError,
            RenewEmployeeFeedSecretMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useRenewEmployeeFeedSecretHook>>>,
    TError,
    RenewEmployeeFeedSecretMutationVariables,
    TContext
> => {
    return useMutation(useRenewEmployeeFeedSecretMutationOptions(options), queryClient);
};
export const getSyncEmployeeFeedUrl = (feedId: string) => {
    return `/workspace/client/feeds/${feedId}/sync`;
};

/**
 * @summary Sync Employee Feed
 */
export const useSyncEmployeeFeedHook = (): ((
    feedId: string,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<Feed>) => {
    const customFetcher = useApiFetch();
    return (feedId: string, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getSyncEmployeeFeedUrl(feedId), {
            ...options,
            method: 'POST',

            schema: Feed,
        });
    };
};

export const getSyncEmployeeFeedMutationKey = () => ['syncEmployeeFeed'] as const;

export const useSyncEmployeeFeedMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useSyncEmployeeFeedHook>>>,
        TError,
        SyncEmployeeFeedMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useSyncEmployeeFeedHook>>>,
    TError,
    SyncEmployeeFeedMutationVariables,
    TContext
> => {
    const mutationKey = getSyncEmployeeFeedMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const syncEmployeeFeed = useSyncEmployeeFeedHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useSyncEmployeeFeedHook>>>,
        SyncEmployeeFeedMutationVariables
    > = (props) => {
        const { feedId } = props ?? {};

        return syncEmployeeFeed(feedId, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/workspace/client/feeds/{feedId}/sync` },
        { operationId: 'sync_employee_feed', operationName: 'syncEmployeeFeed' }
    );

    return customOptions;
};

export type SyncEmployeeFeedMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useSyncEmployeeFeedHook>>>
>;

export type SyncEmployeeFeedMutationError = ErrorType<ErrorResponse>;
export type SyncEmployeeFeedMutationVariables = { feedId: string };

/**
 * @summary Sync Employee Feed
 */
export const useSyncEmployeeFeed = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useSyncEmployeeFeedHook>>>,
            TError,
            SyncEmployeeFeedMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useSyncEmployeeFeedHook>>>,
    TError,
    SyncEmployeeFeedMutationVariables,
    TContext
> => {
    return useMutation(useSyncEmployeeFeedMutationOptions(options), queryClient);
};
